<template>
    <v-app id="sanne">
      <v-main>
        <v-container fluid>
          <v-row no-gutters>
            <v-col>
              <div class="ml-2 mb-4" style="font-weight: 600; font-size: large;">Property Brochure Applicants</div>
            </v-col>
          </v-row>
          <div class="pl-2">
            <v-row cols="12" dense style="display: flex; flex-direction: row; align-items: center; padding-top: 4px; padding-bottom: 8px;">
              <v-col cols="3">
                <v-text-field dense v-model="search" clearable prepend-icon="mdi-magnify" label="Search through all fields" single-line hide-detail />
              </v-col>
              <v-col cols="2">
                  <select_brochure_type :selected_type="sel_type" @getSelection="updateData"/>
              </v-col>   
              <v-col cols="1">
                <v-icon medium color="green" v-on:click="exportDataToExcel()" class="ml-4">mdi-microsoft-excel</v-icon>
              </v-col>
              <v-btn small color="primary" @click="saveApplicantData(true)" class="mr-4">Set as sent</v-btn>
              <v-btn small color="primary" @click="saveApplicantData(false)">Reset as sent</v-btn>
            </v-row>            
            <v-data-table id="x" :headers="getHeaders()" :items="filteredApplicants" :disable-pagination=true
                          hide-default-footer item-key="klnt_email" :loading="loading"
                          loading-text="Loading data...please wait" fixed-header :search="search"
                          show-select :single-select="false" v-model="toggled_applicants"
                          @toggle-select-all="clickAllItems"                          
                          :height="wInnerHeight">   
              <template v-slot:item.klnt_application_dt="{ item }">
                <span>{{ item.klnt_application_dt_display }}</span>
              </template>  
              <template v-slot:item.klnt_dispatch_dt="{ item }">
                <span>{{ item.klnt_dispatch_dt_display }}</span>
              </template>                     
            </v-data-table>                
          </div>
        </v-container>
      </v-main>
      <navBar title="Ares - Marketing" :home="true" type="marketing" />
    </v-app>
  </template>
  
  <script>
  
  import navBar from "@/components/ui/navbars/navbar.vue";
  import select_brochure_type from '@/views/task/marketing/select_brochure_type.vue'

   export default {
    components: {
        navBar,
        select_brochure_type, 
    },
    data() {
      return {      
        loading: false,
        applicants: [],
        search: '',
        sel_type: 'offline',
        toggled_applicants:[],
        wInnerHeight: window.innerHeight - 290, 
      }
    },
    computed: {
        filteredApplicants: function () {
          return this.applicants.filter((applicant) => {
            return this.sel_type==='all'?true:applicant.klnt_application_type===this.sel_type?true:false
          })
        }
    },        
    destroyed() {
      window.removeEventListener("resize", this.resizeEventHandler);
    },    
    created() {
      window.addEventListener("resize", this.resizeEventHandler);  
    },
    mounted(){
      this.getData()
    },
    methods: {
      updateData(data){
        this[data.field] = data.value;
      },
      getHeaders() {
        return [
            { text: "First name", value: "klnt_voornaam", sortable: true},
            { text: "Last name", value: "klnt_naam", sortable: true},
            { text: "E-mail", value: "klnt_email", sortable: true},
            { text: "Type", value: "klnt_application_type", sortable: true},
            { text: "Address", value: "klnt_adres", sortable: true},
            { text: "Postal code", value: "klnt_postcode", sortable: true},
            { text: "City", value: "klnt_plaats", sortable: true},
            { text: "Country", value: "klnt_land", sortable: true},
            { text: "Application", value: "klnt_application_dt", sortable: true},                                    
            { text: "Sent", value: "klnt_dispatch_dt", sortable: true},
        ]
      },
      exportDataToExcel(){
        
        let e_applicants=[];
        
        for(let t = 0; t < this.filteredApplicants.length; t++){
                
          let el = new Object();
          el["First Name"]=this.filteredApplicants[t].klnt_voornaam
          el["Last Name"]=this.filteredApplicants[t].klnt_naam
          el["E-mail"]=this.filteredApplicants[t].klnt_email
          el["Type"]=this.filteredApplicants[t].klnt_application_type;
          el["Address"]=this.filteredApplicants[t].klnt_adres;
          el["Postal Code"]=this.filteredApplicants[t].klnt_postcode;
          el["City"]=this.filteredApplicants[t].klnt_plaats;
          el["Country"]=this.filteredApplicants[t].klnt_land; 
          el["Application"]=new Date(this.filteredApplicants[t].klnt_application_dt); // formatted so it can be sorted as a date in Excel          
          el["Time"]=new Date(this.filteredApplicants[t].klnt_application_dt).toLocaleTimeString(); // We still need the time to be complete   
          el["Sent"]=this.filteredApplicants[t].klnt_dispatch_dt_display===''||this.filteredApplicants[t].klnt_dispatch_dt_display===null?'':new Date(this.filteredApplicants[t].klnt_dispatch_dt).toLocaleString(); // formatted so it can be sorted as a date in Excel
          e_applicants.push(el);
        }
        
        var XLSX = require("xlsx");
        var ws = XLSX.utils.json_to_sheet(e_applicants);
        var wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(wb, ws, "Property Brochure");
        XLSX.writeFile(wb, 'propertybrochure.xlsx');
      },
      loadToggelArray(){
        this.toggled_applicants = []
        this.applicants.forEach(element => {
            if(element.selected) this.toggled_applicants.push(element)
        });
        console.log("loaded", this.toggled_applicants.length)
      },        
      saveApplicantData(v){
            this.$axios
                .post("ares/json/ares/task/marketing/saveKlntGidsVerzonden.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveBrochureSent"
                    },
                    saveBrochureSent: {
                       sent: this.toggled_applicants,
                       setAsSent: v
                    }    
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {
                       this.getData()                       
                    }
                })
        },             
      getData(){
        this.loading = true;
        this.toggled_applicants = []
        this.$axios
            .post("ares/json/ares/task/marketing/getKlntGidsAanvr.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getApplicants"
                },
            })
            .then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.applicants = res.data.getApplicants;
                    this.loadToggelArray()
                }
                this.loading = false;
            })
      },
    }
  };
  
  </script> 
  